import { CONFIG } from "../util/config";

const isAbsoluteUrl = (url) => /^https?:\/\//i.test(url);

const buildServiceUrl = (endpoint, baseUrl = CONFIG.apiUrl) => {
  if (isAbsoluteUrl(endpoint)) return endpoint;
  return `${baseUrl}/${String(endpoint).replace(/^\/+/, "")}`;
};

const readJson = async (response) => {
  try {
    return await response.json();
  } catch (_) {
    return null;
  }
};

export const toPlainObject = (value) => {
  if (value === null || value === undefined) return value;
  return JSON.parse(JSON.stringify(value));
};

export async function fetchServiceJson(endpoint, token, options = {}) {
  try {
    const {
      baseUrl,
      data,
      headers: customHeaders,
      includeJsonContentType = true,
      returnErrorData = false,
      rejectOnError = false,
      ...requestOptions
    } = options;
    const method = requestOptions.method || (data ? "POST" : "GET");
    const headers = {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(includeJsonContentType ? { "Content-Type": "application/json" } : {}),
      ...(customHeaders || {}),
    };

    const res = await fetch(buildServiceUrl(endpoint, baseUrl), {
      ...requestOptions,
      method,
      body: data ? JSON.stringify(data) : requestOptions.body,
      headers,
      next: requestOptions.next || { revalidate: 10 },
    });

    const responseData = await readJson(res);
    if (res.ok) return responseData;
    if (returnErrorData) return responseData;
    if (rejectOnError) return Promise.reject(responseData);
    return null;
  } catch (err) {
    if (options.rejectOnError) return Promise.reject(err);
    console.error("Fetch error:", err);
    return null;
  }
}
